import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/icon/repeat.svg';
const _withScopeId = n => (_pushScopeId("data-v-b954264c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "history__info-order"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = {
  class: "history__info-steps"
};
const _hoisted_4 = {
  class: "history__info-delivery"
};
const _hoisted_5 = {
  class: "history__info-list"
};
const _hoisted_6 = {
  key: 0,
  class: "history__info-tips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InfoOrder = _resolveComponent("InfoOrder");
  const _component_StepsOrder = _resolveComponent("StepsOrder");
  const _component_InfoDelivery = _resolveComponent("InfoDelivery");
  const _component_ListOrders = _resolveComponent("ListOrders");
  const _component_Tips = _resolveComponent("Tips");
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  return _openBlock(), _createBlock(_component_el_collapse_item, {
    name: $props.id
  }, {
    title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_InfoOrder, {
      isVisible: $data.isVisible,
      formattedDate: $data.formattedDate,
      number: $props.order.number,
      items: $data.products,
      totalPrice: $props.order.totalPrice,
      year: $props.order.year,
      count: $data.count,
      class: "info-order"
    }, null, 8, ["isVisible", "formattedDate", "number", "items", "totalPrice", "year", "count"]), !$data.isVisible ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      class: "history__btn-repeat",
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.repeatOrder && $options.repeatOrder(...args), ["stop"]))
    }, [_hoisted_2, _createTextVNode(" Повторить заказ ")])) : _createCommentVNode("", true)])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_StepsOrder, {
      methods: $props.order.methods,
      steps: $props.order.status
    }, null, 8, ["methods", "steps"])]), _createElementVNode("div", _hoisted_4, [$props.order ? (_openBlock(), _createBlock(_component_InfoDelivery, {
      key: 0,
      address: $props.order.address.address,
      input: $props.order.address.input,
      apartment: $props.order.address.apartment,
      floor: $props.order.address.floor,
      "formatted-date": $data.formattedDate,
      payment: $props.order.payment,
      totalPrice: $props.order.totalPrice,
      change: $props.order.change,
      "regular-sticks": $props.order.regularSticks,
      animals: $props.order.animals,
      options: $props.order.options,
      note: $props.order.note
    }, null, 8, ["address", "input", "apartment", "floor", "formatted-date", "payment", "totalPrice", "change", "regular-sticks", "animals", "options", "note"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_ListOrders, {
      products: $data.products
    }, null, 8, ["products"])]), $data.visibleTips && $props.order.tips === false ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_Tips, {
      "total-price": $props.order.totalPrice,
      id: $props.order.id,
      onHideTips: _cache[1] || (_cache[1] = $event => $data.visibleTips = false)
    }, null, 8, ["total-price", "id"])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["name"]);
}